import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import SectionWrapper from '../shared/SectionWrapper';

const ContactSection: React.FC = () => (
  <SectionWrapper
    id="contact"
    sx={{
      py: { xs: 12, md: 20 },
      bgcolor: '#0c0c0c',
    }}
  >
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            mb: 3,
            color: '#ffffff',
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Ready to Talk to Your Data?
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            maxWidth: 460,
            mx: 'auto',
            mb: 6,
            lineHeight: 1.8,
          }}
        >
          Get started with ToStructure or learn how our consulting team
          can help you build custom data and AI solutions.
        </Typography>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="center"
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<EmailIcon />}
            href="mailto:kevin@zerveme.com"
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '0.9rem',
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: '#1d4ed8' },
            }}
          >
            Email Us
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<LinkedInIcon />}
            href="https://www.linkedin.com/in/kevin-singh-908547b4"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '0.9rem',
              borderColor: 'rgba(255, 255, 255, 0.2)',
              color: '#ffffff',
              '&:hover': {
                borderColor: '#ffffff',
                bgcolor: 'transparent',
              },
            }}
          >
            Connect on LinkedIn
          </Button>
        </Stack>
      </Box>
    </motion.div>
  </SectionWrapper>
);

export default ContactSection;
